<script setup lang="ts">
import { cn, PIconBadge } from '@pokerly/ui';
import { IconCheck } from '@tabler/icons-vue';

interface Props {
    active?: boolean;
}

withDefaults(defineProps<Props>(), {
    active: false,
});
</script>

<template>
    <div
        :data-active="active"
        :class="
            cn(
                'group/voting-option',
                'relative',
                'flex',
                'flex-col',
                'gap-4',
                'px-4',
                'py-6',
                'bg-card-primary',
                'border',
                'border-border-default',
                'rounded-lg',
                'w-45',
                'opacity-70',
                'hover:bg-card-primary-hover',
                'hover:opacity-100',
                'hover:shadow-sm',
                'data-[active=true]:bg-card-primary-hover',
                'data-[active=true]:shadow-sm',
                'data-[active=true]:opacity-100',
            )
        "
    >
        <slot></slot>
        <PIconBadge v-if="active" class="absolute top-2 right-2">
            <IconCheck class="size-4" />
        </PIconBadge>
    </div>
</template>

<style scoped></style>
